import {Component, OnDestroy} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ChangePasswordRequest} from "../../../dto/change-password-request";
import {ReplaySubject, takeUntil} from "rxjs";
import {ErrorDTO} from "../../../dto/error-dto";
import {UserService} from "../../../service/user.service";
import {AuthService} from "../../../service/auth.service";
import {ToastrService} from "ngx-toastr";

export const validPasswordPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&\'()*+,-./:;<=>?@\x5B\x5C\x5D^_`{|}~]).{8,}$';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnDestroy {
  inProgress: boolean;
  form: FormGroup;
  inputCP = 'password';
  inputOP = 'password';
  inputP = 'password';
  changePasswordRequest: ChangePasswordRequest;
  destroy: ReplaySubject<void> = new ReplaySubject<void>(1);

  constructor(private userService: UserService,
              private authService: AuthService,
              private toastr: ToastrService) {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      oldPassword: new FormControl('', Validators.required),
      password: new FormControl('', [Validators.required, Validators.pattern(validPasswordPattern)]),
      confirmPassword: new FormControl('', Validators.required),
    });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      this.inProgress = true;
      this.changePasswordRequest = {...this.changePasswordRequest, ...this.form.value};
      this.changePasswordRequest.username = this.authService.getUserName();
      this.userService.updateUserPassword(this.changePasswordRequest).pipe(takeUntil(this.destroy)).subscribe({
        next: (response) => {
          this.inProgress = false;
          this.toastr.success(response.message, '');
        },
        error: (error) => {
          this.inProgress = false;
          let errors = <ErrorDTO[]>error.error.errors;
          errors.forEach(e=> this.toastr.error(e.errorMessage, ''));
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  changeInputTypeCP() {
   this.inputCP = this.inputCP === 'password' ? 'text': 'password';
  }

  changeInputTypeP() {
    this.inputP = this.inputP === 'password' ? 'text': 'password';

  }

  changeInputTypeOP() {
    this.inputOP = this.inputOP === 'password' ? 'text': 'password';

  }
}
